import { requestPost } from "Common/Provider/RestClient"
import { useMutation } from "@tanstack/react-query"

export function useCreateMyToken({ onSuccess, onError, role = 'SuperAdministrator' }) {
    const mutation = useMutation(({ id, password }) => requestPost('/authentication/credential/my-token', { username: id, password }, { Role: role }), {
        onSuccess: (response) => onSuccess ? onSuccess(response) : null,
        onError: (error) => onError ? onError(error) : null,
    })
    return mutation
}